import React from 'react';
import Table, { Cell, HeaderRow, Row } from '../../components/table/Table';
import Inline, { inlineAlignment } from '../../components/layout/Inline';
import Button from '../../components/form/Button';
import { joinDefined, PAGE_ENQUIRIES } from '../../utils/strings';
import { shortDateTimeFromString } from '../../utils/date';
import { DriverPickupIcon } from '../../components/IconIndex';

export default function PickupRunsheet({ pickup, countA }) {
    const spacer = '(not set)';
    const deceased = pickup.Deceased || false;
    const deceasedName =
        (!!deceased && joinDefined([deceased.FirstName, deceased.MiddleName, deceased.Surname], ' ')) || spacer;
    const legacyKey = pickup.LegacyKey;
    const recordID = pickup.ID;
    const pickupDate = shortDateTimeFromString(joinDefined([pickup.Pickup.Date, pickup.Pickup.Time], ' '));
    const locName = pickup.Business.Name || spacer;
    const addr = pickup.Business.PickupAddress && pickup.Business.PickupAddress.ID > 0
        ? pickup.Business.PickupAddress
        : {
            Line1: pickup.Business.AddressLine1,
            Line2: pickup.Business.AddressLine2,
            Suburb: pickup.Business.Suburb,
            State: pickup.Business.State
        };
    const addrString =
        joinDefined(
            [addr.Line1 || addr.AddressLine1, addr.Line2 || addr.AddressLine2, addr.Suburb, addr.State],
            ', '
        ) || spacer;
    const coffinSize = pickup.Pickup.CoffinSize || spacer;
    const deceasedWeight = pickup.EstimatedDeceasedWeight || spacer;
    const comments = pickup.Pickup.Comment || '(none)';
    const staff =
        pickup.Pickup.AssignedStaff && pickup.Pickup.AssignedStaff.length > 0
            ? pickup.Pickup.AssignedStaff.map(member => joinDefined([member.FirstName, member.Surname], ' ')).join(', ')
            : spacer;

    return (
        <div className={'runsheet runsheet--priority'}>
            <Table
                thead={
                    <thead>
                    <HeaderRow pad>
                        <Cell colSpan={2}>
                            <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                                <div>
                                    <span className="runsheet-header">
                                        <DriverPickupIcon /> #{countA} Pickup: {deceasedName}
                                    </span>
                                </div>
                                <p className="header-record">
                                    <Button variant="link-white" href={PAGE_ENQUIRIES + `${recordID}`}>
                                        {legacyKey}
                                    </Button>
                                </p>
                            </Inline>
                        </Cell>
                    </HeaderRow>
                    </thead>
                }>
                <Row pad>
                    <Cell>
                        <h5>Pickup Information</h5>
                        <p>
                            <span className="info">Expected time:&nbsp;</span>
                            {pickupDate}
                        </p>
                        <p>
                            <span className="info">Coffin Size:&nbsp;</span>
                            {coffinSize}
                        </p>
                        <p>
                            <span className="info">Weight:&nbsp;<br /><small>(estimated)</small></span>
                            {deceasedWeight}
                        </p>
                        <p>
                            <span className="info">Comments:&nbsp;</span>
                            <span className="comments">{comments}</span>
                        </p>
                    </Cell>
                    <Cell>
                        <h5>Pickup Location</h5>
                        <p>
                            <span className="info">From:&nbsp;</span>
                            {locName}
                        </p>
                        <p>
                            <span className="info">Address:&nbsp;</span>
                            {addrString}
                        </p>
                        <p>
                            <span className="info">Assigned Driver:&nbsp;</span>
                            {staff}
                        </p>
                    </Cell>
                </Row>
            </Table>
        </div>
    );
}
